export function slugify(text) {
    // Convert to lowercase
    console.log('text is here', text.value)
    let slug = text.toLowerCase();

    // Replace any non-alphanumeric characters with a dash (-)
    slug = slug.replace(/[^a-z0-9]+/g, '-');

    // Remove leading or trailing dashes
    slug = slug.replace(/^-+|-+$/g, '');

    // Replace multiple consecutive dashes or underscores with a single dash
    slug = slug.replace(/[-_]+/g, '-');

    return slug;
}